import { render, staticRenderFns } from "./PrintVolumeTrendDrawer.vue?vue&type=template&id=22b3d0b8&scoped=true"
import script from "./PrintVolumeTrendDrawer.vue?vue&type=script&lang=js"
export * from "./PrintVolumeTrendDrawer.vue?vue&type=script&lang=js"
import style0 from "./PrintVolumeTrendDrawer.vue?vue&type=style&index=0&id=22b3d0b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b3d0b8",
  null
  
)

export default component.exports